<template>
  <v-snackbar v-model="snackbar" :color="color" :multi-line="true"
    :timeout="timeout">
    {{ message }}
    <v-btn dark flat @click="snackbar = false">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    show: Boolean,
    color: {
      type: String,
      default: 'info'
    },
    message: String
  },
  data () {
    return {
      timeout: 6000
    }
  },
  computed: {
    snackbar: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('change', value)
      }
    }
  }
}
</script>

<style></style>
